"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPACER_HEIGHT = void 0;
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const ParsedTemplate_1 = __importDefault(require("../ParsedTemplate"));
require("./styles.css");
exports.SPACER_HEIGHT = 24;
const ChartDescription = _ref => {
  let {
    hovered,
    descriptionLines,
    descriptionTemplate,
    selectedDescriptionTemplate,
    emphasisColor,
    yType,
    label,
    value,
    rowLabel,
    rowPercent,
    totalPercent,
    fontSize = 14
  } = _ref;
  return react_1.default.createElement("span", {
    className: "description-root",
    style: {
      fontSize: `${fontSize}px`,
      minHeight: `${fontSize * descriptionLines}px`,
      maxHeight: `${fontSize * descriptionLines}px`
    }
  }, react_1.default.createElement(ParsedTemplate_1.default, {
    template: hovered ? selectedDescriptionTemplate : descriptionTemplate,
    emphasisColor: emphasisColor,
    yType: yType,
    label: label,
    value: value,
    rowLabel: rowLabel,
    rowPercent: rowPercent,
    totalPercent: totalPercent
  }), react_1.default.createElement("div", {
    style: {
      height: exports.SPACER_HEIGHT
    }
  }));
};
ChartDescription.propTypes = {
  hovered: (0, prop_types_1.shape)({
    group: prop_types_1.string.isRequired,
    category: prop_types_1.string.isRequired,
    metric: prop_types_1.string
  }),
  descriptionLines: prop_types_1.number,
  descriptionTemplate: prop_types_1.string.isRequired,
  selectedDescriptionTemplate: prop_types_1.string.isRequired,
  emphasisColor: prop_types_1.string,
  yType: prop_types_1.string,
  label: prop_types_1.string,
  value: prop_types_1.string,
  rowLabel: prop_types_1.string,
  rowPercent: prop_types_1.string,
  totalPercent: prop_types_1.string,
  fontSize: prop_types_1.number
};
exports.default = ChartDescription;